var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"savings-page"},[_c('SavingsContent'),_c('SavingsCTA')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }